module.exports = __webpack_public_path__ + "static/06-a77d42089d28f88fa8618268305a1ece.jpg";